<!--
 * @Date: 2022-09-13 19:19:03
 * @LastEditTime: 2022-09-28 15:17:40
 * @Description: file content
-->
<template>
  <cube-sticky :pos="scrollY" :check-top="checkTop">
    <div ref="qingxinWrap" class="qingxin-wrap" @scroll="scrollHandler">
      <div class="qx-bg" />
      <cube-sticky-ele>
        <ul class="prepend-header">
          <li
            v-for="item in list"
            :key="item.unique_key"
            :class="{ active: current == item.unique_key }"
            @click="handleTabs(item)"
          >
            {{ item.title }}
          </li>
        </ul>
      </cube-sticky-ele>
      <div
        v-for="item in list"
        :id="item.unique_key"
        :key="item.unique_key"
        :label="item.unique_key"
        :title="item.title"
      >
        <div
          v-if="item.unique_key === 'heart_tree_hole'"
          class="heart-tree-hole"
          :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
        >
          <img
            class="hth-img"
            src="https://resource.chunyu.mobi/@/media/images/2022/09/20/4279/459cca0f5aeb_w957_h351_.png"
            alt=""
          />
          <img
            :src="item.btn_image"
            alt=""
            class="hth-btn"
            @click="
              jumpAppOrH5(item.jump_url, { click_position: '首页去倾诉' })
            "
          />
        </div>
        <div
          v-if="item.unique_key === 'psychology_test'"
          class="psychology-test"
          :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
        >
          <div class="pt-imgs">
            <img
              v-for="(img, index) in item.front_info_list"
              :key="index"
              class="pt-img"
              :src="img.image"
              alt=""
              @click="
                jumpAppOrH5(img.jump_url, {
                  click_position: img.click_position_name,
                })
              "
            />
          </div>
          <img
            :src="item.btn_image"
            alt=""
            class="pt-btn"
            @click="
              jumpAppOrH5(item.btn_url, { click_position: '首页get更多测试' })
            "
          />
        </div>
        <div
          v-if="item.unique_key === 'expert_live'"
          class="expert-live"
          :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
        >
          <div class="el-imgs">
            <div
              v-for="(img, index) in item.front_info_list"
              :key="index"
              class="el-img"
              @click="
                jumpAppOrH5(img.jump_url, {
                  click_position: img.click_position_name,
                })
              "
            >
              <img :src="img.image" />
              <!-- 直播中 -->
              <div v-if="img.status == 'started'" class="tag">
                <img
                  src="https://resource.chunyu.mobi/@/media/images/2022/09/16/0137/c6fe996124e1_w22_h25_.gif"
                />
                直播中
              </div>
              <!-- 直播前 -->
              <div
                v-if="img.status == 'not_start'"
                class="reverse-action-wrapper"
              >
                <div class="live-time">{{ img.start_time }}</div>
                <div v-if="!img.is_reserve" class="reverse-btn">预约</div>
                <div v-else class="reverse-btn reversed">已预约</div>
              </div>
              <!-- 直播结束 -->
              <div v-if="img.status == 'finished'" class="tag tag-finished">
                直播结束
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="item.unique_key === 'story_inn'"
          class="story-inn"
          :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
          @touchstart.stop
        >
          <swiper
            v-if="list.length"
            class="swiper-wrap"
            :options="swiperOption"
          >
            <swiper-slide
              v-for="(img, index) in item.front_info_list"
              :key="index"
              ><div>
                <img class="icon" :src="img.image" /></div
            ></swiper-slide>
            <!-- <swiper-slide v-for="img in item.front_info_list" :key="img.image"
              ><div>
                <img class="icon" :src="img.image" /></div
            ></swiper-slide> -->
            <div
              v-if="list.length"
              slot="pagination"
              class="swiper-pagination"
            />
          </swiper>
          <img
            :src="item.btn_image"
            alt=""
            class="si-btn"
            @click="
              jumpAppOrH5(item.btn_url, {
                click_position: '首页去发帖',
              })
            "
          />
        </div>
        <div
          v-if="item.unique_key === 'allay_sorrow_inn'"
          class="allay-sorrow-inn"
          :style="{ backgroundImage: 'url(' + item.background_image + ')' }"
        >
          <div class="asi-imgs">
            <img
              v-for="(img, index) in item.front_info_list"
              :key="index"
              class="asi-img"
              :src="img.image"
              alt=""
              @click="
                jumpAppOrH5(img.jump_url, {
                  click_position: img.click_position_name,
                })
              "
            />
          </div>
        </div>
      </div>
      <!-- 金币任务 -->
      <div
        ref="coinBar"
        class="coin-mission"
        :style="{ backgroundImage: 'url(' + coinInfo.image + ')' }"
        @click="doMission"
      />
    </div>
  </cube-sticky>
</template>

<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import { getGreenHeartHome, isLogin } from '@/services/index';
import { doPoint, requestEvent } from '@/utils/index';

const wx = require('weixin-js-sdk');

let vm = null;

export default {
  components: {},
  data() {
    return {
      isUserLogin: false,
      checkTop: false,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 1.21, // 设置slider容器能够同时显示的slides数量,可以是小数,设置为2时,如图所示，设置为3则会出现三张完整的active slide
        spaceBetween: -20,
        centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
        loop: true,
        slideToClickedSlide: true, // true:点击slide会过渡到这个slide,默认false
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          click() {
            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
            const { realIndex } = this;
            const index = vm.list.findIndex(
              item => item.unique_key === 'story_inn'
            );
            if (index > -1) {
              vm.jumpAppOrH5(
                vm.list[index].front_info_list[realIndex].jump_url,
                {
                  click_position:
                    vm.list[index].front_info_list[realIndex]
                      .click_position_name,
                }
              );
            }
          },
        },
      },
      slideCurrent: 1,
      scrollY: 0,
      list: [],
      current: '',
      timer: null,
      coinInfo: {},
      uniqueKeyList: [],
      listPos: {},
      handleTab: undefined,
      scrollTimer: null,
      scrollEnd: false,
    };
  },
  watch: {
    scrollY(n) {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        if (n === this.scrollOld) {
          this.handleTab = '';
        }
      }, 200);
      this.scrollOld = n;
    },
  },
  created() {
    this.getGreenHeartHomeList();
    this.doPagePoint('PageView', {
      page_readable_name: '运营活动',
      page_title: '青心计划活动首页',
    });
    vm = this;
  },
  mounted() {
    this.onShare();
  },
  methods: {
    /**
     * @description: 点击金币任务
     */
    async doMission() {
      await this.login(this.coinInfo.jump_url);
      if (this.isUserLogin) this.jumpAppOrH5(this.coinInfo.jump_url);
    },
    /**
     * @description: 获取页面详情
     */
    getGreenHeartHomeList() {
      try {
        getGreenHeartHome()
          .then(res => {
            const { error_code, error_msg, data } = res;
            if (error_code === 0) {
              this.list = data.page_info_list;
              this.coinInfo = data.icon_info;
              this.current = this.list[0].unique_key;
              if (this.list.length) {
                this.uniqueKeyList = this.list.map(item => item.unique_key);
                this.$nextTick(() => {
                  this.getListPos();
                });
              }
            } else {
              this.toast(error_msg || '获取详情失败');
            }
          })
          .catch(e => {
            console.log(e);
          });
      } catch (e) {
        console.log(e);
      }
    },
    getListPos() {
      const list = {};
      this.uniqueKeyList.forEach((item, index) => {
        const el = document.querySelector(`#${item}`);
        const top = this.getElementTop(el);
        list[item] = {
          top,
          next: this.uniqueKeyList[index + 1] || '',
          index,
        };
      });
      this.listPos = list;
    },
    /**
     * 分享设置
     *
     */
    onShare() {
      const params = {
        title: '青心计划，让心轻一点', // 标题
        desc: '我们想给你一点温暖', // 描述
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2022/09/27/886d/7de07f6424b5_w2250_h1800_.png',
        img:
          'https://resource.chunyu.mobi/@/media/images/2022/09/16/9a3e/d9e1beb6e5d6_w800_h800_.jpg', // 分享的图片展示
        link: window.location.href,
        page_title: '青心计划，让心轻一点',
        userName: 'gh_681d3fd5683f', // 安卓
        mini_id: 'gh_681d3fd5683f', // IOS
        need_invitate_id: false,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
      };
      cyShare.app(params);
    },
    /**
     * @description: 页面滚动事件
     * @param {*} e
     */
    scrollHandler(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
      this.scrollY = scrollTop;
      if (scrollTop + clientHeight === scrollHeight) {
        this.scrollEnd = true;
        this.maxScroll = scrollTop;
      } else {
        this.scrollEnd = false;
      }
      for (const item in this.listPos) {
        if (
          this.scrollY >= Number(this.listPos[item].top) - 50 &&
          this.scrollY < Number(this.listPos[this.listPos[item].next].top) - 50
        ) {
          if (this.handleTab) {
            this.current = this.handleTab;
          } else {
            this.current = item;
          }
          // this.handleTab = undefined;
        }
      }
      if (this.$refs.coinBar) {
        this.$refs.coinBar.classList.add('translate-right');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$refs.coinBar.classList.remove('translate-right');
          clearTimeout(this.timer);
        }, 2000);
      }
    },
    /**
     * @description: 点击tab
     * @param {*} unique_key tab值
     */
    handleTabs({ unique_key }) {
      if (this.scrollEnd && this.maxScroll < this.listPos[unique_key].top) {
        this.current = unique_key;
      } else {
        const sel = this.$refs.qingxinWrap;
        this.handleTab = unique_key;
        sel.scrollTo({
          top: this.listPos[unique_key].top - 50,
          left: 100,
          behavior: 'smooth',
        });
      }
    },
    /**
     * 跳转逻辑
     *
     * @param {string} url 商品跳转链接
     * @param dopoint
     */
    async jumpAppOrH5(url, dopoint = {}) {
      if (Object.keys(dopoint)) {
        await this.doPagePoint('AppClick', {
          ...dopoint,
          page_readable_name: '运营活动',
          page_title: '青心计划首页',
        });
      }
      if (cyDetect.isFromCY()) {
        window.location.href = `${url}#OPEN_NEW_WIN`;
      } else if (cyDetect.isFromWechat()) {
        // 微信小程序环境下
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            wx.miniProgram.navigateTo({
              url: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
            });
          } else {
            window.location.href = url;
          }
        });
      } else {
        window.location.href = url;
      }
    },
    /**
     * @description: 请求登录状态
     * @param {*} url 未登录→登录后跳转的url，默认为当前页
     */
    login(url = '') {
      return new Promise((resolve, reject) => {
        isLogin()
          .then(res => {
            const { is_login } = res;
            if (!is_login) {
              requestEvent(url);
            } else {
              this.isUserLogin = true;
            }
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    /**
     * @param type
     * @param data
     * @param type
     * @param data
     * @description: dopoint
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
    getElementTop(elem) {
      let elemTop = elem.offsetTop; // 获得elem元素距相对定位的父元素的top

      elem = elem.offsetParent; // 将elem换成起相对定位的父元素

      while (elem != null) {
        // 只要还有相对定位的父元素

        // 获得父元素 距他父元素的top值,累加到结果中

        elemTop += elem.offsetTop; // 再次将elem换成他相对定位的父元素上;

        elem = elem.offsetParent;
      }

      return elemTop;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.qingxin-wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  padding: rem(210) rem(12) rem(130);
  overflow: auto;
  background-color: #73cae4;
  -webkit-overflow-scrolling: touch;
}
.qx-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: rem(450);
  background-image: url('https://resource.chunyu.mobi/@/media/images/2022/09/20/c753/a30ae7b7623e_w1125_h1301_.jpg');
  background-repeat: no-repeat;
  background-size: 100%;
}
.prepend-header {
  display: flex;
  width: 100%;
  height: rem(43);
  margin-bottom: rem(10);
  padding: rem(5) rem(4);
  color: #006b89;
  font-size: 13px;
  line-height: 34px;
  background: rgba(255, 255, 255, 1);
  border-radius: 43px;
  li {
    width: rem(65);
    padding: 0;
    text-align: center;
    &.active {
      color: #fff;
      font-weight: 600;
      background: #0b89aa;
      border-radius: 17px;
    }
  }
}
.heart-tree-hole {
  position: relative;
  width: 100%;
  height: rem(175);
  margin-top: rem(10);
  padding: rem(44) rem(16) rem(20);
  background-repeat: no-repeat;
  background-size: 100%;
  .hth-img {
    width: 100%;
  }
  .hth-btn {
    position: absolute;
    top: rem(116);
    left: rem(30);
    width: rem(106);
    height: rem(29);
  }
}
.psychology-test {
  position: relative;
  width: 100%;
  height: rem(254);
  margin-top: rem(9);
  padding: rem(70) rem(16) rem(17);
  background-repeat: no-repeat;
  background-size: 100%;
  .pt-imgs {
    display: flex;
    justify-content: space-between;
    width: 100%;
    img {
      width: rem(100);
      height: rem(123);
    }
  }
  .pt-btn {
    display: block;
    width: rem(172);
    height: rem(40);
    margin: rem(12) auto 0;
  }
}
.expert-live {
  width: 100%;
  height: rem(279);
  margin-top: rem(10);
  padding: rem(70) rem(16) rem(17);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .el-imgs {
    display: flex;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    .el-img {
      position: relative;
      width: rem(141);
      height: rem(188);
      margin-right: rem(8);
      .tag {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        width: rem(50);
        height: rem(19);
        padding-left: rem(7);
        color: #fff;
        font-size: 8px;
        background: linear-gradient(90deg, #fe403a, #fe905f);
        border-radius: rem(10) 0 rem(10) 0;
        &-finished {
          background: rgba(0, 0, 0, 0.3);
        }
        img {
          width: rem(7);
          height: rem(6);
          margin-right: rem(3);
        }
      }
      .reverse-action-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: rem(38);
        padding: rem(15) rem(5);
        background-image: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 2%,
          rgba(0, 0, 0, 0.58) 100%
        );
        border-radius: 0 0 8px 8px;
      }
      .live-time {
        flex: 1;
        color: #fff;
        font-size: 11px;
      }
      .reverse-btn {
        flex: 0 0 auto;
        height: rem(24);
        padding: 0 rem(13);
        color: #fff;
        font-size: 12px;
        line-height: rem(24);
        text-align: center;
        background-color: #39d167;
        border-radius: rem(17);

        &.reversed {
          background-color: #c2c2c2;
        }
      }
      > img {
        width: rem(141);
        height: rem(188);
        border-radius: 8px;
      }
    }
  }
  .el-btn {
    display: block;
    width: rem(172);
    height: rem(40);
    margin: rem(12) auto 0;
  }
}
.story-inn {
  width: 100%;
  height: rem(310);
  margin-top: rem(10);
  padding: rem(70) rem(3.5) rem(17);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .si-content-wrap {
    width: rem(282);
    height: rem(160);
    margin: auto;
  }
  .swiper-container {
    padding-bottom: rem(13);
  }
  .swiper-slide {
    transform: scale(0.8);
    // transition: 0.1s;
  }
  .icon {
    width: 100%;
    height: rem(160);
  }
  //swriper自带的类名（选中时的样式）
  .swiper-slide-active {
    transform: scale(1);
  }
  .swiper-pagination {
    bottom: rem(0);
    left: 50%;
    transform: translateX(-50%);
  }
  ::v-deep .swiper-pagination-bullet {
    width: rem(5);
    height: rem(5);
    margin-right: rem(3);
    background: #e4e4e4;
    border-radius: 50%;
    &.swiper-pagination-bullet-active {
      width: rem(9);
      background: #16759c;
      border-radius: 3px;
    }
  }

  .swiper-wrap {
    overflow: hidden;
    transform: translate3d(0, 0, 0);
  }
  .si-btn {
    display: block;
    width: rem(174);
    height: rem(42);
    margin: rem(7) auto 0;
  }
}
.allay-sorrow-inn {
  width: 100%;
  height: rem(210);
  margin-top: rem(9);
  padding: rem(70) rem(16) rem(17);
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .asi-imgs {
    display: flex;
    justify-content: space-between;
    width: 100%;
    img {
      width: rem(100);
      height: rem(121);
    }
  }
  .asi-btn {
    display: block;
    width: rem(172);
    height: rem(40);
    margin: rem(12) auto 0;
  }
}
.coin-mission {
  position: fixed;
  right: 0;
  bottom: rem(123);
  z-index: 10;
  width: rem(72);
  height: rem(72);
  background-image: url('https://resource.chunyu.mobi/@/media/images/2022/09/16/8b51/3f0bbb8a9afd_w216_h216_.gif');
  background-repeat: no-repeat;
  background-size: 100%;
  transition: right 300ms;
  &.translate-right {
    right: rem(-50);
  }
}
// ::v-deep .cube-scroll-nav {
// }
::v-deep .cube-sticky-fixed {
  padding: 0 rem(15);
}
</style>
